var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"google-map"},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"title":"googlemap","src":_vm.googleSrc,"width":_vm.isMobile ? '100%': '100%',"height":"455","frameborder":"0","allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }